function capitalizeFirstLetter(value: string | undefined): string | undefined {
  if (!!!value) return undefined
  return value![0].toUpperCase() + value!.slice(1)
}

export const stringService = {
  capitalizeFirstLetter,
}
